import styled from 'styled-components'
import { m as motion } from 'framer-motion'
import { media, Section, Title } from './globalStyles'
import { ShowNextButton } from './headerStyles'

export const AwardsSection = styled(Section)`
  .Scroller {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    padding-right: 6rem;
    padding-left: 25.641%;
    ${media.lessThan('miniTablet')`
      max-width: none;
      padding: 0 8.5rem 0 25%;
    `};
    ${media.lessThan('phone')`
      padding: 9rem 1.5625rem 3rem;
    `};
    ${media.lessThan('miniPhone')`
      padding-top: 8rem;
      padding-left: 3.5rem;
    `};
    & > div:last-child {
      background: ${(props) => props.theme.superLightGray};
    }
  }
`

export const AwardsWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: auto;
  min-height: 100%;
  overflow-x: hidden;
  ${media.lessThan('phone')`
    display: block;
  `};
`

export const AwardsTitle = styled(Title)`
  font-size: 3.8125rem;
  line-height: 5.0625rem;
  ${media.lessThan('phone')`
    font-size: 3.4375rem;
    line-height: 3.8125rem;
  `};
`

export const AwardsSliderContainer = styled(motion.div)`
  position: relative;
  margin-top: 3.75rem;
  width: 100%;
  ${media.lessThan('phone')`
    margin-top: 0;
    padding-bottom: 2.5rem;
  `};
  .slick-slider {
    padding-bottom: 2.5rem;
  }
  .slick-list {
    padding-bottom: 2rem;
  }
  .slick-dots {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex !important;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    li {
      margin: 0 0.4375rem;
      button {
        width: 1rem;
        height: 1rem;
        padding: 0;
        font-size: 0;
        border-radius: 50%;
        opacity: 0.4;
        background: ${(props) => props.theme.green};
        ${media.greaterThan('phone')`
          transition: all 300ms;
          transition-property: opacity;
          will-change: opacity;
          &:hover {
            opacity: 1;
          }
        `}
      }
      &.slick-active {
        button {
          opacity: 1;
        }
      }
    }
  }
`

export const AwardsNextButton = styled(ShowNextButton)`
  position: absolute;
  width: 3rem;
  height: 3rem;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  svg {
    transform: rotate(-90deg);
  }
`

export const AwardsSliderItem = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  padding: 0 6rem 0 0;
  ${media.lessThan('miniTablet')`
    padding: 0 3rem;
  `};
  ${media.lessThan('phone')`
    padding: 0 1rem;
  `};
  .cover {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 50%;
    .frame {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      padding: 0 2.5rem;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }
  .info {
    padding-top: 2.5rem;
    font-size: 1.25rem;
    line-height: 1.4375rem;
    font-weight: 300;
    letter-spacing: 0.02rem;
    text-align: center;
    ${media.lessThan('desktop15')`
      font-size: 1.1875rem;
      line-height: 1.375rem;
    `};
  }
  .more {
    display: block;
    font-size: 1.375rem;
    line-height: 1.5625rem;
    margin: 1.5rem auto 0;
    color: ${(props) => props.theme.green};
    ${media.greaterThan('phone')`
      transition: color 300ms linear;
      &:hover {
        color: ${(props) => props.theme.orange};
      }
    `}
  }
`
